import { render, staticRenderFns } from "./new_blogArticles.vue?vue&type=template&id=a8a68d60&"
import script from "./new_blogArticles.vue?vue&type=script&lang=js&"
export * from "./new_blogArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports